import { render, staticRenderFns } from "./otherQues.vue?vue&type=template&id=ee7c104e"
import script from "./otherQues.vue?vue&type=script&lang=ts"
export * from "./otherQues.vue?vue&type=script&lang=ts"
import style0 from "./otherQues.vue?vue&type=style&index=0&id=ee7c104e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports